<template>
    <v-container>
        <v-row justify="space-around">

            <v-col>
                <v-card>
                    <v-card-title>
                        Node.js
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-title>
                        AWS
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-card-title>
                        Vue.js
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-title>
                        React.js
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-title>
                        Azure
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-card-title>
                        Vue.js
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-title>
                        React.js
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-title>
                        Azure
                    </v-card-title>
                    <v-card-text>
                        Hit me up.
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Technologies',
  data: () => ({
  }),
};
</script>

<style scoped>
.helper-text {
  color: #007bff;
}
html,body,h1,h2,h3,h4,h5,h6 {font-family: "Roboto", sans-serif}

.left-info-override{
    padding-top: 10px;
}

.text-light-blue{
    color: #4682B4;
}
</style>
